// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Team Billing page */

.billing-page {
  text-align: left;
}

.billing-metric-card {
  cursor: default;
  width: 180px;
}

.billing-review-costs {
  margin: -8px 0 24px;
  font-size: 0.9rem;
}

.billing-review-costs a {
  color: var(--link-color);
  text-decoration: none;
}

.billing-review-costs a:hover {
  text-decoration: underline;
}

.billing-paused-banner {
  border: 1px solid var(--warning-border);
  border-left: 4px solid var(--warning-text);
  background-color: var(--warning-bg);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
  margin-bottom: 20px;
  color: var(--text-color);
  font-size: 0.9rem;
}

.billing-paused-banner ul {
  margin: 6px 0 0;
  padding-left: 18px;
  color: var(--secondary-text-color);
}

.billing-section {
  margin-bottom: 28px;
}

.billing-funding-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  align-items: start;
}

.billing-funding-grid > .billing-section {
  margin-inline: 0;
}

.billing-funding-grid > .billing-section,
.billing-funding-grid .billing-card-form,
.billing-funding-grid .add-funds-amount-label {
  min-width: 0;
}

.billing-funding-grid .billing-card-form input {
  box-sizing: border-box;
  max-width: 100%;
}

.billing-section-divider {
  border: none;
  border-top: 1px solid var(--border-color);
  margin: 0 0 28px;
}

/* A group header above several billing sections — a real heading, unlike
   the uppercase section eyebrows below it. */
.billing-group-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 6px;
}

.billing-section-title {
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.11em;
  color: var(--secondary-text-color);
  margin: 0 0 8px;
}

.billing-charge-cap-value {
  margin: 0 0 4px;
  font-size: 1.05rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--text-color);
}

.billing-request-increase-button {
  margin-top: 8px;
}

.billing-card-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  color: var(--text-color);
}

.billing-card-icon {
  color: var(--secondary-text-color);
}

.billing-card-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

/* Narrow screens: the card description keeps its line; the actions wrap
   to their own row underneath. */
@media (max-width: 700px) {
  .billing-card-row {
    flex-wrap: wrap;
  }

  .billing-card-actions {
    flex-basis: 100%;
  }
}

.billing-inline-form {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin: 8px 0;
}

.billing-inline-form label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0; /* the global label margin-bottom breaks flex-end alignment */
  font-size: 0.8rem;
  color: var(--secondary-text-color);
}

.billing-inline-form input {
  width: 160px;
  padding: 6px 8px;
  font-size: 0.9rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background-color: var(--background-color);
  color: var(--text-color);
}

/* Match the inputs' height so flex-end alignment lines the controls up */
.billing-inline-form .primaryButton,
.billing-inline-form .lightButton {
  padding: 7px 14px;
  font-size: 0.9rem;
}

.billing-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: var(--text-color);
  margin-bottom: 4px;
}

.billing-checkbox-label input {
  width: auto;
}

/* Tables (invoices + recent charges) */

.billing-table-wrap {
  overflow-x: auto;
}

.billing-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.billing-table th {
  text-align: left;
  color: var(--secondary-text-color);
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  padding: 6px 10px;
  border-bottom: 1px solid var(--border-strong);
  white-space: nowrap;
}

.billing-table td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--border-color);
  color: var(--text-color);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

.billing-burndown-cell {
  min-width: 140px;
}

.billing-card-cell {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.billing-card-cell-exp {
  font-size: 0.72rem;
  color: var(--secondary-text-color);
}

.billing-burndown {
  height: 6px;
  border-radius: 3px;
  background-color: var(--border-color);
  overflow: hidden;
  margin-bottom: 3px;
}

.billing-burndown-fill {
  height: 100%;
  border-radius: 3px;
  background-color: var(--link-color);
}

.billing-burndown-text {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: 0.72rem;
  color: var(--secondary-text-color);
}

.billing-receipt-link {
  text-decoration: none;
}

.billing-pagination {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

/* Add funds payment source */

.billing-prepay-source {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
}

/* Auto-renew body greys out while the toggle is off (Save stays active
   so unchecking can be persisted) */

.billing-auto-renew-body.billing-disabled .billing-card-row,
.billing-auto-renew-body.billing-disabled .billing-inline-form label {
  opacity: 0.5;
}

.billing-auto-renew-body.billing-disabled input,
.billing-auto-renew-body.billing-disabled button:disabled {
  cursor: not-allowed;
}

/* Card modals */

.billing-prepay-confirm {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
}

.billing-prepay-confirm-text {
  margin: 0;
  color: var(--text-color);
}

.billing-prepay-confirm label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 0.8rem;
  color: var(--secondary-text-color);
}

.billing-prepay-confirm input {
  padding: 8px;
  font-size: 1rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background-color: var(--background-color);
  color: var(--text-color);
  width: 160px;
}

.billing-prepay-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 8px 0 4px;
  text-align: center;
}

.billing-prepay-success-icon {
  color: var(--success-text);
  font-size: 2.2rem;
}

.billing-prepay-success-amount {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text-color);
}

.billing-modal-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 0;
}

.billing-modal-loading::after {
  content: '';
  width: 28px;
  height: 28px;
  border: 3px solid var(--border-color);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spinner 0.8s ease-in-out infinite;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

.billing-card-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
}

.billing-card-form input {
  padding: 8px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background-color: var(--background-color);
  color: var(--secondary-text-color);
  width: 100%;
}

.billing-card-form input:focus-visible {
  outline: 2px solid var(--link-color);
  outline-offset: 2px;
}

.billing-mock-card-row {
  display: flex;
  gap: 8px;
}

.billing-stripe-card {
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background-color: var(--background-color);
}

/* Add-funds modal */
.add-funds-amount-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
  font-size: 0.8rem;
  color: var(--secondary-text-color);
}

.add-funds-amount-label input {
  padding: 8px;
  font-size: 1rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  background-color: var(--background-color);
  color: var(--text-color);
}

/* "Funds will be added to <team>" — a fixed, checked, uneditable row. */
.add-funds-team-line {
  margin-bottom: 14px;
}
.add-funds-options .add-funds-team-line {
  margin-bottom: 0;
}

.add-funds-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
}

/* Card-form footer: secondary (Cancel) left, submit (Continue) right. */
.billing-card-form-actions {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 8px;
}

.add-funds-autorenew-fields {
  margin: 0;
}

@media (max-width: 700px) {
  .billing-funding-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .billing-funding-grid .billing-card-form-actions {
    flex-wrap: wrap;
  }
}

/* ------------------------------------------------------------------ */
/* Plan section                                                        */
/* ------------------------------------------------------------------ */

.plan-current {
  margin: 8px 0 14px;
}

.plan-current-name {
  font-size: 1.15rem;
  font-weight: 600;
  margin-left: 8px;
}

.plan-status-chip {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-radius: 999px;
  padding: 3px 10px;
  background: var(--accent-tint);
  color: var(--accent-tint-text);
}

.plan-status-past_due,
.plan-status-trial_expired {
  background: var(--warning-bg);
  color: var(--warning-text);
  border: 1px solid var(--warning-border);
}

.plan-status-paused,
.plan-status-canceled {
  background: transparent;
  color: var(--danger-text);
  border: 1px solid var(--danger-border);
}

.plan-hint-banner,
.plan-scheduled-banner {
  background: var(--accent-tint);
  color: var(--accent-tint-text);
  border-radius: 8px;
  padding: 10px 14px;
  margin: 10px 0;
}

.plan-tier-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
  margin: 12px 0;
}

.plan-tier-card {
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.plan-tier-current {
  border-color: var(--accent-tint-text);
}

.plan-tier-hinted {
  outline: 2px solid var(--accent-tint-text);
  outline-offset: 1px;
}

.plan-tier-name {
  font-weight: 600;
  font-size: 1.05rem;
}

.plan-tier-price {
  font-size: 1.4rem;
  font-weight: 700;
}

.plan-tier-unit {
  font-size: 0.78rem;
  font-weight: 400;
  color: var(--secondary-text-color);
}

.plan-tier-features {
  margin: 0;
  padding-left: 18px;
  font-size: 0.85rem;
  color: var(--secondary-text-color);
  flex-grow: 1;
}

.plan-tier-features li {
  margin-bottom: 4px;
}

.plan-tier-badge {
  align-self: flex-start;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--accent-tint-text);
  background: var(--accent-tint);
  border-radius: 999px;
  padding: 4px 12px;
}

.billing-page .linkButton {
  background: none;
  border: none;
  padding: 0;
  color: var(--accent-tint-text);
  text-decoration: underline;
  cursor: pointer;
  font-size: inherit;
}

.billing-page .linkButton:disabled {
  opacity: 0.5;
  cursor: default;
}

.plan-invoices {
  margin-top: 14px;
}

.plan-invoices .metrics-table {
  width: 100%;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 16px;
}

.plan-row {
  margin: 8px 0 10px;
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: 10px;
  padding: 14px 16px;
}

.plan-row-main {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.plan-change-link {
  margin-left: auto;
  font-weight: 600;
}

.plan-tier-limits {
  border-top: 1px solid var(--border-color);
  padding-top: 8px;
}

.plan-tier-limits-title {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--secondary-text-color);
  margin-bottom: 4px;
}

/* What a team gives up by choosing this plan. Cautionary rather than
   forbidding: the switch is still available, the cost is just stated. */
.plan-tier-changes {
  border: 1px solid var(--warning-border);
  background: var(--warning-bg);
  color: var(--warning-text);
  border-radius: 6px;
  padding: 8px 10px;
  margin-top: 8px;
}

.plan-tier-changes-title {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--warning-heading);
  margin-bottom: 4px;
}

.plan-tier-changes .plan-tier-features li {
  color: var(--warning-text);
}

.plan-feature-losses {
  border-left: 3px solid var(--warning-border);
  background: var(--warning-bg);
  color: var(--warning-text);
  border-radius: 4px;
  padding: 8px 12px;
  margin-top: 12px;
}

.plan-feature-losses p {
  font-weight: 600;
  margin: 0 0 4px;
}

.plan-feature-losses ul {
  margin: 0;
  padding-left: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/TeamBilling.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;6CAC6C;AAC7C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;iCACiC;AACjC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAS,EAAE,6DAA6D;EACxE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,+BAA+B;EAC/B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,yEAAyE;AACzE;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,uCAAuC;;AAEvC;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;oCACoC;;AAEpC;;EAEE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,+BAA+B;EAC/B,yCAAyC;EACzC,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,sCAAsC;EACtC,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,yCAAyC;EACzC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,+BAA+B;EAC/B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,wEAAwE;AACxE;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,uEAAuE;AACvE,wEAAwE;AACxE,uEAAuE;;AAEvE;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;EAC7B,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;EAEE,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;wEACwE;AACxE;EACE,uCAAuC;EACvC,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB","sourcesContent":["/* Team Billing page */\n\n.billing-page {\n  text-align: left;\n}\n\n.billing-metric-card {\n  cursor: default;\n  width: 180px;\n}\n\n.billing-review-costs {\n  margin: -8px 0 24px;\n  font-size: 0.9rem;\n}\n\n.billing-review-costs a {\n  color: var(--link-color);\n  text-decoration: none;\n}\n\n.billing-review-costs a:hover {\n  text-decoration: underline;\n}\n\n.billing-paused-banner {\n  border: 1px solid var(--warning-border);\n  border-left: 4px solid var(--warning-text);\n  background-color: var(--warning-bg);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n  margin-bottom: 20px;\n  color: var(--text-color);\n  font-size: 0.9rem;\n}\n\n.billing-paused-banner ul {\n  margin: 6px 0 0;\n  padding-left: 18px;\n  color: var(--secondary-text-color);\n}\n\n.billing-section {\n  margin-bottom: 28px;\n}\n\n.billing-funding-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n  align-items: start;\n}\n\n.billing-funding-grid > .billing-section {\n  margin-inline: 0;\n}\n\n.billing-funding-grid > .billing-section,\n.billing-funding-grid .billing-card-form,\n.billing-funding-grid .add-funds-amount-label {\n  min-width: 0;\n}\n\n.billing-funding-grid .billing-card-form input {\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.billing-section-divider {\n  border: none;\n  border-top: 1px solid var(--border-color);\n  margin: 0 0 28px;\n}\n\n/* A group header above several billing sections — a real heading, unlike\n   the uppercase section eyebrows below it. */\n.billing-group-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text-color);\n  margin: 0 0 6px;\n}\n\n.billing-section-title {\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.11em;\n  color: var(--secondary-text-color);\n  margin: 0 0 8px;\n}\n\n.billing-charge-cap-value {\n  margin: 0 0 4px;\n  font-size: 1.05rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: var(--text-color);\n}\n\n.billing-request-increase-button {\n  margin-top: 8px;\n}\n\n.billing-card-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  color: var(--text-color);\n}\n\n.billing-card-icon {\n  color: var(--secondary-text-color);\n}\n\n.billing-card-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Narrow screens: the card description keeps its line; the actions wrap\n   to their own row underneath. */\n@media (max-width: 700px) {\n  .billing-card-row {\n    flex-wrap: wrap;\n  }\n\n  .billing-card-actions {\n    flex-basis: 100%;\n  }\n}\n\n.billing-inline-form {\n  display: flex;\n  align-items: flex-end;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin: 8px 0;\n}\n\n.billing-inline-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0; /* the global label margin-bottom breaks flex-end alignment */\n  font-size: 0.8rem;\n  color: var(--secondary-text-color);\n}\n\n.billing-inline-form input {\n  width: 160px;\n  padding: 6px 8px;\n  font-size: 0.9rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n/* Match the inputs' height so flex-end alignment lines the controls up */\n.billing-inline-form .primaryButton,\n.billing-inline-form .lightButton {\n  padding: 7px 14px;\n  font-size: 0.9rem;\n}\n\n.billing-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  color: var(--text-color);\n  margin-bottom: 4px;\n}\n\n.billing-checkbox-label input {\n  width: auto;\n}\n\n/* Tables (invoices + recent charges) */\n\n.billing-table-wrap {\n  overflow-x: auto;\n}\n\n.billing-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.billing-table th {\n  text-align: left;\n  color: var(--secondary-text-color);\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  padding: 6px 10px;\n  border-bottom: 1px solid var(--border-strong);\n  white-space: nowrap;\n}\n\n.billing-table td {\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--border-color);\n  color: var(--text-color);\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\n.billing-burndown-cell {\n  min-width: 140px;\n}\n\n.billing-card-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.billing-card-cell-exp {\n  font-size: 0.72rem;\n  color: var(--secondary-text-color);\n}\n\n.billing-burndown {\n  height: 6px;\n  border-radius: 3px;\n  background-color: var(--border-color);\n  overflow: hidden;\n  margin-bottom: 3px;\n}\n\n.billing-burndown-fill {\n  height: 100%;\n  border-radius: 3px;\n  background-color: var(--link-color);\n}\n\n.billing-burndown-text {\n  font-family: var(--font-mono);\n  font-variant-numeric: tabular-nums;\n  font-size: 0.72rem;\n  color: var(--secondary-text-color);\n}\n\n.billing-receipt-link {\n  text-decoration: none;\n}\n\n.billing-pagination {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n/* Add funds payment source */\n\n.billing-prepay-source {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n/* Auto-renew body greys out while the toggle is off (Save stays active\n   so unchecking can be persisted) */\n\n.billing-auto-renew-body.billing-disabled .billing-card-row,\n.billing-auto-renew-body.billing-disabled .billing-inline-form label {\n  opacity: 0.5;\n}\n\n.billing-auto-renew-body.billing-disabled input,\n.billing-auto-renew-body.billing-disabled button:disabled {\n  cursor: not-allowed;\n}\n\n/* Card modals */\n\n.billing-prepay-confirm {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  text-align: left;\n}\n\n.billing-prepay-confirm-text {\n  margin: 0;\n  color: var(--text-color);\n}\n\n.billing-prepay-confirm label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 0.8rem;\n  color: var(--secondary-text-color);\n}\n\n.billing-prepay-confirm input {\n  padding: 8px;\n  font-size: 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background-color: var(--background-color);\n  color: var(--text-color);\n  width: 160px;\n}\n\n.billing-prepay-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0 4px;\n  text-align: center;\n}\n\n.billing-prepay-success-icon {\n  color: var(--success-text);\n  font-size: 2.2rem;\n}\n\n.billing-prepay-success-amount {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text-color);\n}\n\n.billing-modal-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 32px 0;\n}\n\n.billing-modal-loading::after {\n  content: '';\n  width: 28px;\n  height: 28px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spinner 0.8s ease-in-out infinite;\n}\n\n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.billing-card-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  text-align: left;\n}\n\n.billing-card-form input {\n  padding: 8px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background-color: var(--background-color);\n  color: var(--secondary-text-color);\n  width: 100%;\n}\n\n.billing-card-form input:focus-visible {\n  outline: 2px solid var(--link-color);\n  outline-offset: 2px;\n}\n\n.billing-mock-card-row {\n  display: flex;\n  gap: 8px;\n}\n\n.billing-stripe-card {\n  padding: 10px;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background-color: var(--background-color);\n}\n\n/* Add-funds modal */\n.add-funds-amount-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 12px;\n  font-size: 0.8rem;\n  color: var(--secondary-text-color);\n}\n\n.add-funds-amount-label input {\n  padding: 8px;\n  font-size: 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background-color: var(--background-color);\n  color: var(--text-color);\n}\n\n/* \"Funds will be added to <team>\" — a fixed, checked, uneditable row. */\n.add-funds-team-line {\n  margin-bottom: 14px;\n}\n.add-funds-options .add-funds-team-line {\n  margin-bottom: 0;\n}\n\n.add-funds-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  text-align: left;\n}\n\n/* Card-form footer: secondary (Cancel) left, submit (Continue) right. */\n.billing-card-form-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 8px;\n}\n\n.add-funds-autorenew-fields {\n  margin: 0;\n}\n\n@media (max-width: 700px) {\n  .billing-funding-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .billing-funding-grid .billing-card-form-actions {\n    flex-wrap: wrap;\n  }\n}\n\n/* ------------------------------------------------------------------ */\n/* Plan section                                                        */\n/* ------------------------------------------------------------------ */\n\n.plan-current {\n  margin: 8px 0 14px;\n}\n\n.plan-current-name {\n  font-size: 1.15rem;\n  font-weight: 600;\n  margin-left: 8px;\n}\n\n.plan-status-chip {\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border-radius: 999px;\n  padding: 3px 10px;\n  background: var(--accent-tint);\n  color: var(--accent-tint-text);\n}\n\n.plan-status-past_due,\n.plan-status-trial_expired {\n  background: var(--warning-bg);\n  color: var(--warning-text);\n  border: 1px solid var(--warning-border);\n}\n\n.plan-status-paused,\n.plan-status-canceled {\n  background: transparent;\n  color: var(--danger-text);\n  border: 1px solid var(--danger-border);\n}\n\n.plan-hint-banner,\n.plan-scheduled-banner {\n  background: var(--accent-tint);\n  color: var(--accent-tint-text);\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin: 10px 0;\n}\n\n.plan-tier-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 14px;\n  margin: 12px 0;\n}\n\n.plan-tier-card {\n  background: var(--card-background);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.plan-tier-current {\n  border-color: var(--accent-tint-text);\n}\n\n.plan-tier-hinted {\n  outline: 2px solid var(--accent-tint-text);\n  outline-offset: 1px;\n}\n\n.plan-tier-name {\n  font-weight: 600;\n  font-size: 1.05rem;\n}\n\n.plan-tier-price {\n  font-size: 1.4rem;\n  font-weight: 700;\n}\n\n.plan-tier-unit {\n  font-size: 0.78rem;\n  font-weight: 400;\n  color: var(--secondary-text-color);\n}\n\n.plan-tier-features {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 0.85rem;\n  color: var(--secondary-text-color);\n  flex-grow: 1;\n}\n\n.plan-tier-features li {\n  margin-bottom: 4px;\n}\n\n.plan-tier-badge {\n  align-self: flex-start;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--accent-tint-text);\n  background: var(--accent-tint);\n  border-radius: 999px;\n  padding: 4px 12px;\n}\n\n.billing-page .linkButton {\n  background: none;\n  border: none;\n  padding: 0;\n  color: var(--accent-tint-text);\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: inherit;\n}\n\n.billing-page .linkButton:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.plan-invoices {\n  margin-top: 14px;\n}\n\n.plan-invoices .metrics-table {\n  width: 100%;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n.plan-row {\n  margin: 8px 0 10px;\n  background: var(--card-background);\n  border: 1px solid var(--border-color);\n  border-radius: 10px;\n  padding: 14px 16px;\n}\n\n.plan-row-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.plan-change-link {\n  margin-left: auto;\n  font-weight: 600;\n}\n\n.plan-tier-limits {\n  border-top: 1px solid var(--border-color);\n  padding-top: 8px;\n}\n\n.plan-tier-limits-title {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--secondary-text-color);\n  margin-bottom: 4px;\n}\n\n/* What a team gives up by choosing this plan. Cautionary rather than\n   forbidding: the switch is still available, the cost is just stated. */\n.plan-tier-changes {\n  border: 1px solid var(--warning-border);\n  background: var(--warning-bg);\n  color: var(--warning-text);\n  border-radius: 6px;\n  padding: 8px 10px;\n  margin-top: 8px;\n}\n\n.plan-tier-changes-title {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--warning-heading);\n  margin-bottom: 4px;\n}\n\n.plan-tier-changes .plan-tier-features li {\n  color: var(--warning-text);\n}\n\n.plan-feature-losses {\n  border-left: 3px solid var(--warning-border);\n  background: var(--warning-bg);\n  color: var(--warning-text);\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-top: 12px;\n}\n\n.plan-feature-losses p {\n  font-weight: 600;\n  margin: 0 0 4px;\n}\n\n.plan-feature-losses ul {\n  margin: 0;\n  padding-left: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
